<div class="error-box">
    <div class="error-body text-center">
        <h1>404</h1>
        <h3 class="text-uppercase">Página no encontrada!</h3>
        <p class="text-muted m-t-30 m-b-30">Verifique link e intente nuevamente. Muchas gracias.</p>
    </div>
    <footer class="footer text-center">© 2021 NOBIS</footer>
</div>